import React from 'react';
import IprSheetBody from '../ipr-stripping-sheet/components/IprSheetBody';
import { buildEmptyIpr } from '../../lib/iprToothData';

export default function WorkshopStrippingSheetContent({ caseId, iprData, iprLoading }) {
  if (!caseId) {
    return (
      <p className="text-sm text-muted-foreground text-center py-12">
        Aucune fiche stripping liée à ce lot (conception non rattachée).
      </p>
    );
  }

  if (iprLoading) {
    return (
      <div className="flex flex-col items-center gap-3 py-16">
        <div className="h-8 w-8 rounded-full border-2 border-primary border-t-transparent animate-spin" />
        <p className="text-sm text-muted-foreground">Chargement de la fiche…</p>
      </div>
    );
  }

  return (
    <div className="space-y-3 pb-2">
      <IprSheetBody
        iprData={iprData || buildEmptyIpr()}
        readOnly
        variant="compact"
        showPatientHeader={false}
        showClinicalNotes={false}
        selectedTooth={null}
        onToothSelect={() => {}}
      />
      <p className="text-xs text-muted-foreground text-center px-2 leading-relaxed">
        Lecture seule — utilisez « Modifier la fiche » pour éditer (contacts IPR, boutons, attachements…).
      </p>
    </div>
  );
}
